import { HireflixErrorTypes, HireflixNotification } from './types';

export function getNotificationText(
  notification: HireflixNotification,
  t: (arg0: string, ...args: string[]) => string,
): string {
  const method =
    notification.type === 'EMAIL'
      ? t('integrations.hireflix.job.app.info.notifications.email')
      : notification.type === 'SMS'
        ? t('integrations.hireflix.job.app.info.notifications.sms')
        : t('integrations.hireflix.job.app.info.notifications.whatsapp');
  const sentTime =
    notification.hours === 0
      ? t('integrations.hireflix.job.app.info.notifications.type.immediately')
      : t(
          'integrations.hireflix.job.app.info.notifications.type.afterhours',
          notification.hours.toString(),
        );

  return `${method} • ${sentTime}`;
}

export function getErrorMessage(
  errorKey: HireflixErrorTypes,
  t: (arg0: string, ...args: string[]) => string,
) {
  switch (errorKey) {
    case 'INVALID_API_KEY':
      return t('integrations.hireflix.errors.invalidapikey');
    case 'CANDIDATE_ALREADY_EXISTS':
      return t('integrations.hireflix.errors.candidatealreadyexists');
    case 'EXPIRED_ACCOUNT':
      return t('integrations.hireflix.errors.expiredaccount');
    default:
      return errorKey;
  }
}
